import { render, staticRenderFns } from "./registerV2.vue?vue&type=template&id=c573dfc0&scoped=true&"
import script from "./registerV2.vue?vue&type=script&lang=js&"
export * from "./registerV2.vue?vue&type=script&lang=js&"
import style0 from "./registerV2.vue?vue&type=style&index=0&id=c573dfc0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c573dfc0",
  null
  
)

export default component.exports